// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1wh-N","buttons":"Footer_buttons__2i8A1"};